import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  empty: {
    ...theme.cardStyles.highlight,
    minHeight: theme.spacing(16)
  }
});

export default makeStyles(styles);
